import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { errorJsonHasErrors } from "./Input_Fns.jsx";
import { set } from "lodash";

export const InputNumber = ({
  number,
  label = "Value",
  name = "Value",
  required = false,
  min = 0,
  max = 120,
  onChange,
  tooltip = "",
  onError = null,
  width = 80,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""

    if (e.target.name === name) {
      if (number < min || number > max) {
        //err = "Please enter " + label
        err = "" + min + " to " + max

      }
      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
    }
  }
  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={label}
        name={name}
        type="number"
        slotProps={{
          htmlInput: {
            min: min,
            max: max,
            step: 1,
          },
        }}
        required={required}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        size="small"
        sx={{ width: width }}
        value={number}
        onChange={onChange}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};


export const InputRepeat = ({
  number,
  label = "Repeat",
  name = "Repeat",
  required = false,
  min = 0,
  max = 60,
  onChange,
  tooltip = "",
  onError = null,
  width = 80,
  ...others
}) => {
  return (
    <InputNumber
      number={number}
      label={label}
      name={name}
      required={required}
      min={min}
      max={max}
      onChange={onChange}
      tooltip={tooltip}
      onError={onError}
      width={width}
      {...others}
    />
  )
}